import React, { useEffect, useState } from "react";
import { Col, Layout, Row, Tooltip, Typography } from "antd";
import { connect, useSelector } from "react-redux";
import Feedback from "../Utilities/Feedback";
import { LoadingOutlined } from "@ant-design/icons";
import { getApplicationById } from "../Redux/Consultant/reducer";
import Header from "../Authorized/Header";
import constants from "../Redux/constants";
import moment from "moment";
import {
  StyledTitle,
  StyledText,
  StyledTag,
  StyledLink,
} from "../styled-components/components";

const ApplicationDetail = (props) => {
  const [loading, setLoading] = useState(true);
  const { applicationId } = props.match.params;
  const { getApplicationById } = props;
  const { applicationDetail } = useSelector((state) => state.consultantStore);
  useEffect(() => {
    const getApplicationDetail = async () => {
      const { responseStatus } = await getApplicationById(applicationId);
      if (responseStatus === constants.status.success) {
        setLoading(false);
      }
    };
    getApplicationDetail();
  }, [applicationId, getApplicationById]);
  return (
    <Layout>
      <Header />
      <Layout.Content>
        <Col>
          {loading ? (
            <Feedback
              icon={<LoadingOutlined />}
              title="Loading the Application"
            ></Feedback>
          ) : (
            <Col>
              <Application applicationDetail={applicationDetail} />
            </Col>
          )}
        </Col>
      </Layout.Content>
    </Layout>
  );
};

const Application = ({ applicationDetail }) => {
  const date = (appliedDate) => moment.utc(appliedDate).from(moment());
  const actualDate = (appliedDate) => moment(appliedDate).format("YYYY-MM-DD");
  const { jobDetails } = applicationDetail;
  return (
    <Col>
      <Col
        md={{ span: 10 }}
        style={{
          padding: "1vh",
          background: "#ffffff",
          border: "1px solid #f4f4f4",
          margin: "2vh",
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: "2vh",
        }}
      >
        <Col style={{ padding: "1vh" }}>
          <Row justify="space-between" align="middle">
            <Col xl={{ span: 20 }}>
              <Row justify="space-between" align="middle">
                <Col xl={{ span: 24 }}>
                  <StyledTitle level={5} textColor="#9CD8CA">
                    {jobDetails.title}
                  </StyledTitle>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row justify="space-between">
                <Col>
                  <StyledTag>{jobDetails.typeRequirement}</StyledTag>
                </Col>
                <Col>
                  <StyledTag>{jobDetails.T24Release}</StyledTag>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row style={{ margin: "1vh" }}>
            {jobDetails.additionalComments ? (
              <Typography.Paragraph
                ellipsis={
                  jobDetails.additionalComments.length > 20
                    ? {
                        rows: 1,
                        expandable: true,
                        symbol: (
                          <StyledText textColor="#1565d8">more</StyledText>
                        ),
                      }
                    : false
                }
              >
                {jobDetails.additionalComments}
              </Typography.Paragraph>
            ) : null}
          </Row>
          <Row>
            <Col>
              <Typography.Text strong>Attachments</Typography.Text>
              {jobDetails.attachments &&
                jobDetails.attachments.map((eachFile) => {
                  return (
                    <Col>
                      <StyledLink>{eachFile.fileName}</StyledLink>
                    </Col>
                  );
                })}
            </Col>
          </Row>
          <Col>
            <Row>
              <Typography.Paragraph>
                {applicationDetail.comment}
              </Typography.Paragraph>
            </Row>
            <Row>
              <Typography.Text>
                Applied On :
                <Tooltip title={actualDate(applicationDetail.äppliedDate)}>
                  {date(applicationDetail.äppliedDate)}
                </Tooltip>
              </Typography.Text>
            </Row>
          </Col>
        </Col>
      </Col>
    </Col>
  );
};

const mapDispatchToReducer = (dispatch) => {
  return {
    getApplicationById: (applicationId) =>
      dispatch(getApplicationById(applicationId)),
  };
};
export default connect(null, mapDispatchToReducer)(ApplicationDetail);
